import { CONDICION } from 'Constants'

export const ClientsCTACTE = (data, edit, dataBefore) => {
  const condIvaLabel = CONDICION.find((item) => item.id === data.cond_iva)?.label
  const tipoResponsable = dataBefore.data.tipo_responsable.find(
    (item) => item.value === data.tipo_responsable
  )?.name
  return [
    {
      class: 'textfield',
      type: 'number',
      name: 'id',
      label: 'Nº de cliente',
      value: data.id,
      disabled: true,
      sm: 6,
      xs: 12,
    },
    {
      class: 'textfield',
      name: 'razon_social',
      label: 'Razón social',
      value: data.razon_social,
      disabled: true,
      sm: 6,
      xs: 12,
    },
    {
      class: 'textfield',
      sm: 4,
      xs: 12,
      name: 'cond_iva',
      label: 'Condición',
      value: condIvaLabel,
      disabled: true,
    },
    {
      class: 'textfield',
      name: 'cuit',
      label: 'CUIT/CUIL/DNI',
      value: data.cuit,
      sm: 4,
      xs: 12,
      disabled: true,
    },
    {
      class: 'textfield',
      sm: 4,
      xs: 12,
      name: 'tipo_responsable',
      label: 'Tipo responsable',
      value: typeof data.tipo_responsable === 'string' ? data.tipo_responsable : tipoResponsable,
      disabled: true,
    },
    {
      class: 'textfield',
      sm: 4,
      xs: 12,
      name: 'provincia',
      label: 'Provincia',
      value: data.provincia,
      disabled: true,
    },
    {
      class: 'textfield',
      sm: 4,
      xs: 12,
      name: 'localidad',
      label: 'Localidad',
      value: data.localidad ? data.localidad : null,
      disabled: true,
    },
    {
      class: 'textfield',
      name: 'direccion',
      label: 'Dirección',
      value: data.direccion,
      sm: 4,
      xs: 12,
      disabled: true,
    },
  ]
}
